import { Text } from '@react-pdf/renderer'

import { globalPDFStyles } from '../../styles'
import { MeasuresPDFProps } from '..'

export const MeasurePDFHeader = ({
  measureData,
  question,
}: MeasuresPDFProps) => (
  <>
    <Text style={globalPDFStyles.title}>
      {measureData?.form?.name || 'N/A'}
    </Text>
    <Text style={globalPDFStyles.subtitle}>{question?.text}</Text>
  </>
)
